export default {
    headline: 'Request OTP',
    contact_number_lbl: 'กรอกรหัส OTP 6 หลัก ที่ส่งผ่าน SMS หมายเลข {0}',
    ref_code: 'หมายเลขอ้างอิง : ',

    please_enter_otp: 'กรุณากรอกรหัส OTP',
    time_left: 'รหัสจะหมดอายุภายใน',
    second: 'นาที',

    required: 'Please enter your OTP.',
    too_short: 'Please enter otp',
    otp_timeout: 'OTP time out in',
    resend_otp: 'ส่ง OTP อีกครั้ง',

    incorrect_otp: 'รหัส OTP ไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง',
    cancel: "ยกเลิก",
    btn_confirm: "ยืนยัน"
}
